import React, { Component } from 'react'
import { AxiosResponse } from "axios";
import { connect } from 'react-redux';

import trans from "trans"

import { find } from "lodash"

import FileInputComponent from 'react-file-input-previews-base64'

import {
    Icon,
    Theme,
    Grid,
    GridCell,
    Spinner,
    InputGroup,
    Select,
    Checkbox,
    Paginator,
    css,
} from "@bdfx/mergado-ui-kit"

import { ALL_PRODUCTS_QUERY } from "../template-edit/forms/queries-form";
import { WatermarkGroupImageType, WatermarkGroupType } from "../products/types";

import {
    projectId,
    addImagesToWatermarksGroup,
    getProductsForWatermarkGroupsFromFie,
    getProductsForWatermarkGroupsFromMergado,
} from "app/helpers/api";

import { OneImageGrid, renderWatermarkMask } from './watermark-groups-images';

import {
    Query,
    Template,
} from "app/types/model-types";

import { ID, ReduxList, intboolean } from 'app/types/app-types';
import { getSelectedAltLevels, NO_IMAGE_URL } from 'shape-edit/forms/helpers';
import { MIN_IMAGES_WITH_MASKS_TO_PUBLISH } from './watermark-groups-select';
import { RandomProduct } from 'shape-edit/types';

interface Props {
    isAlt: boolean
    randomProduct: RandomProduct
    queries: ReduxList<Query>
    templates: ReduxList<Template>
    watermarkGroups: WatermarkGroupType[]
    watermarkGroup: WatermarkGroupType
    updateWatermarkGroups: Function
    close: Function
    setSelectedGroupId: Function

}

interface State {
    addImagesFrom: AddImagesFromType
    productsForWatermarks: ProductsForWatermarksType
    newGroupName: string
    isLoading: boolean
    nonWorkingUrls: string[]
    page: number
    limit: number
}

export type ProductsForWatermarksType = {
    totalProducts: number
    products: WMProductItemType[]
    templateId: number
    projectId: number
    watermarkGroupId: number
    queryIds: string
    withWatermarks: intboolean
    withMask: intboolean
    isAlt: boolean
}
export const initProductsForWatermarks: ProductsForWatermarksType = {
    totalProducts: null,
    products: null,
    templateId: null,
    watermarkGroupId: null,
    projectId: projectId,
    queryIds: null,
    withWatermarks: 0,
    withMask: 0,
    isAlt: null,
}

export type AddImagesFromType = 'mergado' | 'fie' | 'upload'
export type WMProductItemType = {
    is_alt: boolean
    level: number
    product_id: number
    template_id: number
    image_or_alt_url: string
    image_or_alt_id: number
    image_or_alt_hash: string
    width: number
    height: number
    filename: string
    user_set_objects: string
}


class WatermarkGroupsAddProducts extends Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            addImagesFrom: props.templates.atLeastOneActive ? 'fie' : 'mergado',
            productsForWatermarks: initProductsForWatermarks,
            newGroupName: '',
            isLoading: false,
            nonWorkingUrls: [],
            page: 1,
            limit: 10,
        }
    }

    updateLimit = () => {
        const el = document.getElementById('watermark-grid-main')
        if (el) {
            const box = el.getBoundingClientRect()
            const productsInRow = Math.max(10, Math.ceil((box.width-160)/(166+15)))
            const newLimit = 3*productsInRow
            this.setState({limit: newLimit})
            return newLimit
        }
        return 10
    }

    componentWillUnmount(): void {
        window.removeEventListener('resize', this.updateLimit)
    }

    componentDidMount() {
        const newLimit = this.updateLimit()
        window.addEventListener('resize', this.updateLimit)
        this.updateProductsForWatermarkGroups(this.state.page, newLimit, initProductsForWatermarks.withMask, initProductsForWatermarks.withWatermarks, initProductsForWatermarks.templateId, initProductsForWatermarks.queryIds)
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if (prevState) {
            if (prevState.addImagesFrom !== this.state.addImagesFrom) {
                if (this.state.addImagesFrom === 'upload') {
                    this.setState({ productsForWatermarks: initProductsForWatermarks })
                } else {
                    this.updateProductsForWatermarkGroups(this.state.page, this.state.limit, initProductsForWatermarks.withMask, initProductsForWatermarks.withWatermarks, initProductsForWatermarks.templateId, initProductsForWatermarks.queryIds)
                }
            }
        }
    }


    updateProductsForWatermarkGroups = (page: number, limit: number, withMask: intboolean, withWatermarks: intboolean, templateId: ID, queryIds: string) => {
        const { addImagesFrom } = this.state
        const { watermarkGroup, isAlt, randomProduct } = this.props
        const a = getSelectedAltLevels()

        switch (addImagesFrom) {
            case 'fie':
                this.setState({ isLoading: true })
                getProductsForWatermarkGroupsFromFie(templateId, watermarkGroup?.id, queryIds, page, limit, withMask, withWatermarks, isAlt, a?.levels, a?.mode, randomProduct?.id)
                    .then((response: AxiosResponse<ProductsForWatermarksType>) => {
                        this.setState({ productsForWatermarks: { ...response.data }, nonWorkingUrls: [] })
                    })
                    .catch(e => console.error('cannot get products', e))
                    .finally(() => this.setState({ isLoading: false }))
                break
            case 'mergado':
                this.setState({ isLoading: true })
                getProductsForWatermarkGroupsFromMergado(templateId, watermarkGroup?.id, queryIds, page, limit, isAlt, a?.levels, a?.mode, randomProduct?.id)
                    .then((response: AxiosResponse<ProductsForWatermarksType>) => {
                        this.setState({ productsForWatermarks: { ...response.data }, nonWorkingUrls: [] })
                    })
                    .catch(e => console.error('cannot get products', e))
                    .finally(() => this.setState({ isLoading: false }))
                break
            default:
                console.debug(`unknown source ${addImagesFrom}`)
                break
        }
    }

    transProductsCount = (count: number) => {
        if (count === 1) {
            return trans('one_product')
        } else if (count > 1 && count < 5) {
            return trans('less_than_five_products')
        } else {
            return trans('products_count')
        }
    }

    addToGroup = (uploadedProducts: WMProductItemType[], selectedWatermarkGroupId: number) => {
        this.setState({ isLoading: true })
        addImagesToWatermarksGroup(uploadedProducts, selectedWatermarkGroupId)
            .then((response: AxiosResponse<WatermarkGroupType>) => {
                const watermarkGroup = response.data    //muze obsahovat nove id

                this.props.setSelectedGroupId(watermarkGroup.id)
                this.props.updateWatermarkGroups()

                const imagesWithMasksInwatermarkGroup = watermarkGroup && watermarkGroup.images ? watermarkGroup.images.filter(i => i.user_set_objects).length : 0
                if (imagesWithMasksInwatermarkGroup >= MIN_IMAGES_WITH_MASKS_TO_PUBLISH) {
                    this.props.close()
                }
            })
            .catch((e) => {
                console.error('error', e)
            })
            .finally(() => this.setState({ isLoading: false }))
    }

    renderPaginator = () => {
        const { productsForWatermarks, page, limit } = this.state

        return (productsForWatermarks && productsForWatermarks.totalProducts > 0) ?
            <Paginator
                showFirstAndLast={true}
                showPrevAndNext={false}
                maxLinks={3}
                labelFirst={`««`}
                labelPrevious={`«`}
                labelNext={`»`}
                labelLast={`»»`}
                currentPage={page}
                lastPage={Math.ceil(productsForWatermarks.totalProducts / limit)}
                onPageChange={(newPage) => {
                    this.setState({page: newPage})
                    this.updateProductsForWatermarkGroups(newPage, limit, productsForWatermarks.withMask, productsForWatermarks.withWatermarks, productsForWatermarks.templateId, productsForWatermarks.queryIds)
                }} /> : <span />
    }

    renderFilters = () => {
        const { addImagesFrom, productsForWatermarks, page, limit } = this.state
        const { templates, queries } = this.props

        const availableTemplates = (templates && templates.isLoaded && templates.data) ? templates.data.filter(t => t.active).map((t) => {
            return {
                label: `${t.name}`,
                value: `${t.id}`,
            }
        }) : null

        const availableQueries = (queries.isLoaded && queries.data) ? queries.data.map((q) => {
            return {
                label: `${q.id}: ${q.name === ALL_PRODUCTS_QUERY ? trans("all_products") : q.name} (${q.product_count})`,
                value: `${q.id}`,
            }
        }) : null

        return <Grid cols={'1fr 1fr'}>
            {addImagesFrom === 'fie' &&
                <React.Fragment>
                    <GridCell style={{ alignSelf: 'center' }}>
                        <Checkbox
                            key={`with_watermarks_${productsForWatermarks.withWatermarks}`}
                            value={productsForWatermarks.withWatermarks}
                            label={trans('has_watermark')}
                            onChange={(e) => {
                                this.setState({
                                    productsForWatermarks: {
                                        ...productsForWatermarks,
                                        withWatermarks: e,
                                    },
                                    page: 1
                                })
                                this.updateProductsForWatermarkGroups(1, limit, productsForWatermarks.withMask, e, productsForWatermarks.templateId, productsForWatermarks.queryIds)
                            }}
                        />

                        <Checkbox
                            key={`with_mask_${productsForWatermarks.withMask}`}
                            value={productsForWatermarks.withMask}
                            label={`${trans('with_objects')}`}
                            onChange={(e) => {
                                this.setState({
                                    productsForWatermarks: {
                                        ...productsForWatermarks,
                                        withMask: e,
                                    }, page: 1,
                                })
                                this.updateProductsForWatermarkGroups(1, limit, e, productsForWatermarks.withWatermarks, productsForWatermarks.templateId, productsForWatermarks.queryIds)
                            }}
                        />
                    </GridCell>

                    <GridCell style={{ alignSelf: 'center' }}>
                        {(availableTemplates && availableTemplates.length > 0) &&
                            <Select
                                value={productsForWatermarks?.templateId ? `${productsForWatermarks.templateId}` : ''}
                                options={availableTemplates}
                                label={trans('filter_template')}
                                onChange={(e) => {
                                    const updated = {
                                        ...productsForWatermarks,
                                        templateId: e,
                                    }
                                    this.setState({ productsForWatermarks: updated, page: 1 })
                                    this.updateProductsForWatermarkGroups(1, limit, updated.withMask, updated.withWatermarks, updated.templateId, updated.queryIds)
                                }}
                            />
                        }
                    </GridCell>
                </React.Fragment>
            }

            {addImagesFrom === 'mergado' &&
                <React.Fragment>
                    <GridCell style={{ alignSelf: 'center' }}>
                        {(availableQueries && availableQueries.length > 0) &&
                            <Select
                                value={productsForWatermarks?.queryIds || ''}
                                multiple={false}
                                closeOnChange={true}
                                options={availableQueries}
                                label={trans('queries')}
                                onChange={(e) => {
                                    const updated = {
                                        ...productsForWatermarks,
                                        queryIds: e,
                                    }
                                    this.setState({ productsForWatermarks: updated, page: 1 })
                                    this.updateProductsForWatermarkGroups(1, limit, updated.withMask, updated.withWatermarks, updated.templateId, updated.queryIds)
                                }}
                            />
                        }
                    </GridCell>
                </React.Fragment>
            }
        </Grid>
    }

    renderUpload = () => {
        const { watermarkGroup } = this.props

        return <FileInputComponent
            parentStyle={{ marginTop: 0, display: "inline-block" }}
            labelStyle={{ fontSize: 14 }}
            labelText={''}
            imagePreview={false}
            multiple={true}
            buttonComponent={
                <span className={'clickable'}>
                    <Icon
                        type={'upload'}
                        text={trans('upload_images')}
                        size={40}
                        color={Theme.steelblue}
                    />
                </span>
            }
            callbackFunction={(files) => {
                if (Array.isArray(files)) {
                    const images = files.map(file => file.base64)
                    if (images) {
                        const uploadedProducts: WMProductItemType[] = images.map(newImage => {
                            return {
                                is_alt: null,
                                level: null,
                                product_id: null,
                                image_or_alt_id: null,
                                image_or_alt_url: newImage,
                                image_or_alt_hash: null,
                                template_id: null,
                                width: null,
                                height: null,
                                filename: null,
                                user_set_objects: null,
                            }
                        })
                        this.addToGroup(uploadedProducts, watermarkGroup?.id)
                    }
                }
            }}
            accept="image/*"
        />
    }

    renderSelectSource = () => {
        const { addImagesFrom } = this.state

        return <InputGroup
                    singleChoice={true}
                    onChange={(value) => this.setState({ addImagesFrom: value, page: 1 })}
                    value={addImagesFrom}
                    items={[
                        { value: 'mergado', label: trans('images_from_mergado') },
                        { value: 'fie', label: trans('images_from_fie') },
                        { value: 'upload', label: trans('upload_images') },
                    ]}
                    style={{ margin: '20px 0px 0px 0px', width: '100%' }}
                />
    }

    addNonWorkingUrl = (imageUrl: string) => {
        if (!this.state.nonWorkingUrls.includes(imageUrl)) {
            this.setState({ nonWorkingUrls: [...this.state.nonWorkingUrls, imageUrl] })
        }
    }

    toggleSelectUrl = (toggleProduct: WMProductItemType): void => {
        const { watermarkGroup } = this.props
        this.addToGroup([toggleProduct], watermarkGroup?.id)
    }

    render() {
        const { watermarkGroups, watermarkGroup } = this.props
        const { addImagesFrom, productsForWatermarks, isLoading, nonWorkingUrls } = this.state

        return (
            <React.Fragment>
                <GridCell col={'1/-1'} className={'centering'}>
                    {this.renderSelectSource()}
                    {addImagesFrom === 'upload' &&
                        <UploadDiv>
                            {this.renderUpload()}
                        </UploadDiv>
                    }
                </GridCell>

                <GridCell col={'1/-1'}>
                    {this.renderFilters()}
                </GridCell>

                <GridCell col={'1/-1'}>
                    {this.renderPaginator()}
                </GridCell>

                {(addImagesFrom !== 'upload' && productsForWatermarks.totalProducts > 0) &&
                    productsForWatermarks.products
                    .map(product => {
                        const isBadUrl = nonWorkingUrls.includes(product.image_or_alt_url)
                        const productIdInfo = product.product_id ? ` (mergado product ${product.product_id})` : ''

                        let groupNames = []
                        watermarkGroups.forEach(watermarkGroup => {
                            const currentGroup = find(watermarkGroup.images, (i: WatermarkGroupImageType) => {
                                return i.filename === product.filename
                            })
                            if (currentGroup) {
                                groupNames.push(watermarkGroup.name)
                            }
                        })

                        let classNames = []
                        if (!isBadUrl) {
                            classNames.push('clickable')
                        }

                        if (isLoading) {
                            classNames.push('muk-helper-loading')
                        }

                        const usedImageHashes = watermarkGroup && watermarkGroup.images && Array.isArray(watermarkGroup.images) ?
                            watermarkGroup.images.map(image => image.image_or_alt_hash) : []

                        const usedImageFilenames = watermarkGroup && watermarkGroup.images && Array.isArray(watermarkGroup.images) ?
                            watermarkGroup.images.map(image => image.filename) : []

                        const alreadyUsed = usedImageHashes.includes(product.image_or_alt_hash) || usedImageFilenames.includes(product.filename)

                        const addClass = alreadyUsed ? 'already-used' : ''

                        return <GridCell key={`product_for_watermarks_${product.product_id}_${nonWorkingUrls.length}`} className={classNames.join(' ')}>
                            <OneImageGrid dataIsBadUrl={isBadUrl} onClick={(e) => !alreadyUsed && !isBadUrl ? this.toggleSelectUrl(product) : undefined}>
                                <div className={`centering ${addClass}`} style={{position: 'relative'}}>
                                    {product.user_set_objects ? renderWatermarkMask(product, product.image_or_alt_url) :
                                        <img
                                            className={`${!isBadUrl ? 'checker' : 'bad-url'} max-image-size`}
                                            src={product.image_or_alt_url}
                                            title={`${product.image_or_alt_url}${productIdInfo}`}
                                            onError={(e) => {
                                                if (e.currentTarget.src !== NO_IMAGE_URL) {
                                                    this.addNonWorkingUrl(product.image_or_alt_url)
                                                    e.currentTarget.src = NO_IMAGE_URL
                                                }
                                            }}
                                        />
                                    }
                                </div>
                                {alreadyUsed &&
                                <span title={trans('already_used_image')} style={{cursor: 'not-allowed'}}>
                                    <Icon type="check-square-o" style={{position: 'absolute', top: 35, left: 35}} color={'#a3a3a3cf'} size={100} />
                                </span>
                                }
                            </OneImageGrid>
                        </GridCell>
                    })
                }

                {isLoading &&
                    <Spinner type={'bubbles'} />
                }

            </React.Fragment>
        )
    }
}

const UploadDiv = css('div')({
    minHeight: '200px',
    display: 'grid',
    ' > div': {
        display: 'grid',
        alignSelf: 'center',
    },
})

function mapStateToProps(state) {
    return {
        randomProduct: state.randomProduct,
        queries: state.queries,
        templates: state.templates,
        isAlt: state.isAlt,
    }
}

export default connect(mapStateToProps, {
})(WatermarkGroupsAddProducts)
